<template>
  <div>
    <div class="filters-banner d-flex align-items-center justify-content-between">
      <div class="filters-left d-flex align-items-center" style="margin-top: 1%;">
        <b-form-select v-model="filters.tourName" :options="optionsCache.tourNames" class="filter-item mr-2"
          placeholder="Tour Name" @change="fetchTours(1)" />
        <b-form-select v-model="filters.tourCode" :options="optionsCache.tourCodes" class="filter-item mr-2"
          placeholder="Tour Code" @change="fetchTours(1)" />
        <b-form-select v-model="filters.cruiseLine" :options="optionsCache.cruiseLines" class="filter-item mr-2"
          placeholder="Cruise" @change="fetchTours(1)" />
        <b-form-select v-model="filters.year" :options="optionsCache.years" class="filter-item mr-2" placeholder="Year"
          @change="fetchTours(1)" />
        <b-form-select v-model="filters.port" :options="optionsCache.ports" class="filter-item mr-2" placeholder="Port"
          @change="fetchTours(1)" />
        <h5 class="tour-count mb-0 mr-2">Tours ({{ pagination.total }})</h5>
        <b-form-input v-model="searchQuery" class="filter-item search-bar mr-2" placeholder="Search..."
          @input="fetchTours(1)" />
        <b-button variant="secondary" v-b-tooltip.hover title="Reset Filters" @click="resetFilters"
          class="filter-item reset-btn mr-2">Reset</b-button>
        <b-button class="filter-item add-tour-btn" variant="primary" v-b-tooltip.hover title="Add New Tour"
          @click="showForm = !showForm">
          {{ showForm ? 'Cancel' : 'Add Tour' }}
        </b-button>
      </div>
    </div>
    <div v-if="showForm">
      <TourFormRiver @close="closeForm" @tour-added="fetchTours" :tour="selectedTour" />
    </div>
    <div class="table-responsive">
      <table class="table table-striped custom-table">
        <thead class="thead-dark">
          <tr>
            <th><input type="checkbox" @change="selectAll" /></th>
            <th @click="setSort('id')"> Id<span v-if="sortField === 'id'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="setSort('tourName')">Tour Name<span v-if="sortField === 'tourName'">{{ sortOrder === 'asc' ? '▲'
              : '▼' }}</span></th>
            <th @click="setSort('tourCode')">Tour Code<span v-if="sortField === 'tourCode'">{{ sortOrder === 'asc' ? '▲'
              : '▼' }}</span></th>
            <th @click="setSort('cruiseLine')">Cruise Line<span v-if="sortField === 'cruiseLine'">{{ sortOrder === 'asc'
              ? '▲' : '▼' }}</span></th>
            <th @click="setSort('port')">Port<span v-if="sortField === 'port'">{{ sortOrder === 'asc' ? '▲' : '▼'
            }}</span></th>
            <th @click="setSort('year')">Year<span v-if="sortField === 'year'">{{ sortOrder === 'asc' ? '▲' : '▼'
            }}</span></th>
            <th>City</th>
            <th>Duration</th>
            <th>Pax Min</th>
            <th>Pax Max</th>
            <th>Overview</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tour in tours" :key="tour.id" @contextmenu.prevent="showContextMenu($event, tour)"
            @click="selectedTours.includes(tour.id) ? selectedTours.splice(selectedTours.indexOf(tour.id), 1) : selectedTours.push(tour.id)"
            @dblclick="viewTour(tour.id)" class="tour-row">
            <td><input type="checkbox" v-model="selectedTours" :value="tour.id" /></td>
            <td>{{ tour.id }}</td>
            <td>{{ tour.attributes.tourName }}</td>
            <td>{{ tour.attributes.tourCode }}</td>
            <td>{{ tour.attributes.cruiseLine }}</td>
            <td>{{ tour.attributes.port?.data?.attributes?.city }}</td>
            <td>{{ tour.attributes.year }}</td>
            <td>
              <ul>
                <li v-for="city in tour.attributes.cities.data" :key="city.id">
                  {{ city.attributes.city }}
                </li>
              </ul>
            </td>
            <td>{{ tour.attributes.duration }}</td>
            <td>{{ tour.attributes.paxMin }}</td>
            <td>{{ tour.attributes.paxMax }}</td>
            <td>
              <template v-if="tour.attributes.overview && tour.attributes.overview.length > 0">
                <table class="nested-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Type</th>
                      <th>Factor</th>
                      <th>Input.Mar %</th>
                      <th>Calco.Mar %</th>
                      <th>Buy</th>
                      <th>Sell</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in tour.attributes.overview" :key="item.name">
                      <td>{{ item.name || 'No item available' }}</td>
                      <td>{{ item.type || 'No type available' }}</td>
                      <td>{{ item.factor || 'No factor available' }}</td>
                      <td>{{ item.margin || 'No margin available' }}</td>
                      <td>{{ formatMargin(item.calculatedMargin || calculateMargin(item.calculatedBuy, item.sellPrice))
                        }}</td>
                      <td>{{ formatPrice(item.calculatedBuy || 'N/A', tourCity(tour)) }}</td>
                      <td>{{ formatPrice(item.sellPrice || 'N/A', tourCity(tour)) }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template v-else>
                <p>No overview items available</p>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="mt-3 d-flex justify-content-center">
      <b-pagination v-model="pagination.currentPage" :total-rows="pagination.total" :per-page="pagination.perPage"
        @change="fetchTours" aria-controls="tour-table"></b-pagination>
    </div>
    <div v-if="showMenu" :style="{ top: `${menuY}px`, left: `${menuX}px` }" class="context-menu" ref="contextMenu">
      <ul>
        <li @click="viewTour(selectedTour.id)">View</li>
        <li @click="editSelectedTours">Edit</li>
        <li @click="cloneSelectedTours">Clone</li>
        <li @click="removeSelectedTours">Delete</li>
        <li @click="exportToExcel">Export(Internal)</li>
        <li @click="exportToExcelClient">Export(Client)</li>
      </ul>
    </div>

    <!-- Modal for cloning a tour -->
    <b-modal v-model="showCloneModal" title="Clone Tour" @ok="processClone">
      <b-form @submit.stop.prevent="processClone">
        <b-form-group label="Cruise Line:">
          <b-form-select v-model="newCruiseLine" :options="cruiseLineOptions" required></b-form-select>
        </b-form-group>
        <b-form-group label="Enter the year for the cloned tour:">
          <b-form-input v-model="newYear" type="number" required></b-form-input>
        </b-form-group>
        <b-form-group label="Tour Name:">
          <b-form-input v-model="newTourName" :value="selectedTour.attributes.tourName + ' (Clone)'"
            required></b-form-input>
        </b-form-group>
        <b-form-group label="Tour Code:">
          <b-form-input v-model="newTourCode" :value="selectedTour.attributes.tourCode" required></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>

    <!-- Modal for confirmation about missing items -->
    <b-modal v-model="showConfirmModal" title="Confirm Creation">
      <div v-if="matchedItems.length > 0" class="success-box">
        <h4>Matched Items</h4>
        <ul>
          <li v-for="item in matchedItems" :key="item.id">{{ item.attributes.item }}</li>
        </ul>
      </div>
      <div v-if="missingItems.length > 0" class="danger-box">
        <h4>Missing Items</h4>
        <ul>
          <li v-for="item in missingItems" :key="item.id">{{ item.name }}</li>
        </ul>
      </div>
      <div v-if="missingItems.length === 0 && matchedItems.length > 0">
        <p>All items matched for the selected year. Do you want to create the tour?</p>
      </div>
      <div v-if="missingItems.length > 0 && matchedItems.length > 0">
        <p>Do you still want to create the tour with missing items?</p>
      </div>
      <div v-if="missingItems.length === 0 && matchedItems.length === 0">
        <p>No items are in this tour. Do you want to create the tour without items?</p>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="showConfirmModal = false">Cancel</b-button>
        <b-button variant="primary" @click="createClonedTour">Create Tour</b-button>
        <router-link :to="{ path: '/calculation/itemlist' }">
          <b-button variant="dark">Create New Item</b-button>
        </router-link>
      </template>
    </b-modal>

    <!-- Modal for deletion confirmation -->
    <b-modal v-model="showConfirmDeleteModal" title="Confirm Deletion">
      <p>Are you sure you want to delete the selected tours?</p>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="showConfirmDeleteModal = false">Cancel</b-button>
        <b-button variant="danger" @click="confirmDeleteTours">Delete</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import TourFormRiver from './TourFormRiver.vue';
import ServiceFormRiver from './ServiceFormRiver.vue';
import { formatPrice } from '../Helper/PriceDisplay.js';
import { generateExcel } from '../Helper/GenerateTourexcelriver.js';
import { generateExcelClient } from '../Helper/GenerateTourexcelClient.js';
import qs from 'qs';

export default {
  components: {
    TourFormRiver,
    ServiceFormRiver
  },
  data() {
    return {
      selectedRows: [],
      tours: [],
      loading: true,
      showForm: false,
      selectedTour: null,
      showCloneModal: false,
      showConfirmModal: false,
      showConfirmDeleteModal: false,
      newCruiseLine: '',
      newYear: '',
      newTourName: '',
      newTourCode: '',
      matchedItems: [],
      missingItems: [],
      clonedTour: null,
      selectedTours: [],
      showMenu: false,
      menuX: 0,
      menuY: 0,
      filters: {
        tourName: '',
        tourCode: '',
        cruiseLine: '',
        year: '',
        port: ''
      },
      optionsCache: {
        tourNames: [],
        tourCodes: [],
        years: [],
        ports: [],
        cruiseLines: []
      },
      pagination: {
        currentPage: 1,
        perPage: 25,
        total: 0
      },
      searchQuery: '',
      sortField: 'id',
      sortOrder: 'desc' // 'asc' or 'desc'
    };
  },
  computed: {
    cruiseLineOptions() {
      return [
        "AMAWaterways",
        "Avalon",
        "APT Cruises",
        "AHI",
        "PGreat Rail Journeys",
        "Noble Caledonia",
        "Riviera Travel",
        "Tauck",
        "Riverside",
        "Viking River Cruises",
        "Viva Cruises",
        "Uniworld",
        "Nicko Cruises",
        "Scenic Cruises"
      ];
    }
  },
  async created() {
    this.fetchOptions();
    await this.fetchTours();
    document.addEventListener('click', this.handleClickOutside);
    this.loadFilters();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    formatPrice,
    formatMargin(value) {
      return value !== null && !isNaN(value) ? `${value.toFixed(2)}` : 'N/A';
    },
    tourCity(tour) {
      const cities = tour.attributes.cities?.data;
      if (!cities || cities.length === 0) return null;
      const prague = cities.find(c => c.attributes.city === 'Prague');
      return prague ? 'Prague' : cities[0].attributes.city;
    },
    calculateMargin(buyPrice, sellPrice) {
      if (!buyPrice || !sellPrice || buyPrice === 0) return null;
      return ((sellPrice - buyPrice) / buyPrice) * 100;
    },
    setSort(field) {
      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortOrder = 'asc';
      }
    },
    async fetchTours(page = this.pagination.currentPage) {
      this.loading = true;
      try {
        const queryParams = {
          populate: '*',
          sort: [`${this.sortField}:${this.sortOrder}`],
          pagination: {
            page: page,
            pageSize: this.pagination.perPage
          },
          filters: {}
        };

        if (this.filters.tourName) queryParams.filters.tourName = { $eq: this.filters.tourName };
        if (this.filters.tourCode) queryParams.filters.tourCode = { $eq: this.filters.tourCode };
        if (this.filters.cruiseLine) queryParams.filters.cruiseLine = { $eq: this.filters.cruiseLine };
        if (this.filters.year) queryParams.filters.year = { $eq: this.filters.year };
        if (this.filters.port) queryParams.filters.port = { city: { $eq: this.filters.port } };

        if (this.searchQuery) {
          queryParams.filters.$or = [
            { tourName: { $containsi: this.searchQuery } },
            { tourCode: { $containsi: this.searchQuery } },
            { cruiseLine: { $containsi: this.searchQuery } }
          ];
        }

        const queryString = qs.stringify(queryParams, { encodeValuesOnly: true });
        const response = await this.$xhr.get(`/api/tourrivers?${queryString}`);

        this.tours = response.data.data;
        this.pagination.total = response.data.meta.pagination.total;
        this.pagination.currentPage = page;

      } catch (error) {
        console.error('Error fetching tours:', error);
      } finally {
        this.loading = false;
      }
    },
    async fetchOptions() {
      try {
        const response = await this.$xhr.get('/api/tourrivers/filters');
        const data = response.data;
        this.optionsCache.tourNames = [{ value: '', text: 'Tour Name' }, ...(data.tourNames || []).map(n => ({ value: n, text: n }))];
        this.optionsCache.tourCodes = [{ value: '', text: 'Tour Code' }, ...(data.tourCodes || []).map(c => ({ value: c, text: c }))];
        this.optionsCache.cruiseLines = [{ value: '', text: 'Cruise Line' }, ...(data.cruiseLines || []).map(l => ({ value: l, text: l }))];
        this.optionsCache.years = [{ value: '', text: 'Year' }, ...(data.years || []).map(y => ({ value: y, text: y }))];
        this.optionsCache.ports = [{ value: '', text: 'Port' }, ...(data.ports || []).map(p => ({ value: p, text: p }))];
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    },
    viewTour(tourId) {
      this.$router.push({ name: 'TourDetailsriver', params: { id: tourId } });
    },
    showContextMenu(event, tour) {
      event.preventDefault();
      this.selectedTour = tour;
      this.showMenu = true;
      this.menuX = event.clientX;
      this.menuY = event.clientY;
    },
    handleClickOutside(event) {
      const contextMenu = this.$refs.contextMenu;
      if (contextMenu && !contextMenu.contains(event.target)) {
        this.showMenu = false;
      }
    },
    editSelectedTours() {
      this.showForm = true;
      this.showMenu = false;
    },
    cloneSelectedTours() {
      this.newTourName = `${this.selectedTour.attributes.tourName} (Clone)`;
      this.newTourCode = this.selectedTour.attributes.tourCode;
      this.newYear = this.selectedTour.attributes.year;
      this.newCruiseLine = this.selectedTour.attributes.cruiseLine; // Preselect current cruise line
      this.showCloneModal = true;
      this.showMenu = false;
    },
    closeForm() {
      this.showForm = false;
      this.selectedTour = null;
    },
    removeSelectedTours() {
      this.showConfirmDeleteModal = true; // Show confirmation modal
      this.showMenu = false;
    },
    async confirmDeleteTours() {
      this.showConfirmDeleteModal = false; // Close the confirmation modal

      for (const tourId of this.selectedTours) {
        await this.$xhr.delete(`/api/tourrivers/${tourId}`);
      }

      this.fetchTours(); // Refresh the tours list
      this.$bvToast.toast('Tours deleted successfully!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },
    async processClone() {
      const isSameYear = parseInt(this.newYear) === parseInt(this.selectedTour.attributes.year);
      const isSameCruiseLine = this.newCruiseLine === this.selectedTour.attributes.cruiseLine;
      const isSameTourName = this.newTourName === this.selectedTour.attributes.tourName;
      const isSameTourCode = this.newTourCode === this.selectedTour.attributes.tourCode;

      // Only restrict if ALL four fields are the same
      if (isSameCruiseLine && isSameTourName && isSameTourCode && isSameYear) {
        this.$bvToast.toast('Cannot create an exact duplicate tour. Please change at least one field (Cruise Line, Tour Name, Tour Code, or Year).', {
          title: 'Clone Aborted',
          variant: 'danger',
          solid: true
        });
        this.showCloneModal = false;
        return;
      }

      // Check if a tour with the same name, cruise line, code, and year already exists
      const existingTourResponse = await this.$xhr.get(`/api/tourrivers?filters[tourName][$eq]=${encodeURIComponent(this.newTourName)}&filters[cruiseLine][$eq]=${encodeURIComponent(this.newCruiseLine)}&filters[tourCode][$eq]=${encodeURIComponent(this.newTourCode)}&filters[year][$eq]=${this.newYear}`);

      if (existingTourResponse.data.data.length > 0) {
        this.$bvToast.toast('A tour with the same name, code, cruise line, and year already exists.', {
          title: 'Clone Aborted',
          variant: 'danger',
          solid: true
        });
        this.showCloneModal = false;
        return; // Exit if a duplicate is found
      }

      let itemFactor = {};
      let margin = {};

      if (isSameYear) {
        // If same year, we can just copy items and factors directly
        this.matchedItems = this.selectedTour.attributes.item?.data || [];
        this.missingItems = [];

        // Copy original itemFactor and margin directly
        itemFactor = { ...(this.selectedTour.attributes.itemFactor || {}) };
        margin = { ...(this.selectedTour.attributes.margin || {}) };
      } else {
        // Fetch items for the new year
        let newYearItems = [];
        let pageNum = 1;
        const pageSize = 500;
        let hasMore = true;

        while (hasMore) {
          const response = await this.$xhr.get(`/api/servicerivers?filters[year][$eq]=${this.newYear}&pagination[page]=${pageNum}&pagination[pageSize]=${pageSize}`);
          const data = response.data.data;
          const meta = response.data.meta;
          newYearItems = newYearItems.concat(data);

          if (newYearItems.length >= meta.pagination.total || data.length < pageSize) {
            hasMore = false;
          } else {
            pageNum++;
          }
        }

        // Ensure item is an array and get existing items from the tour
        const existingItems = Array.isArray(this.selectedTour.attributes.item?.data)
          ? this.selectedTour.attributes.item.data.map(item => ({ id: item.id, name: item.attributes.item }))
          : [];

        // Separate matched and missing items
        this.matchedItems = [];
        this.missingItems = [];

        existingItems.forEach(existingItem => {
          const matchedItem = newYearItems.find(newItem => newItem.attributes.item.trim() === existingItem.name.trim());
          if (matchedItem) {
            this.matchedItems.push(matchedItem);
          } else {
            this.missingItems.push(existingItem);
          }
        });

        // Map original itemFactor and margin as much as possible for new items
        const oldIdToNameMap = {};
        if (Array.isArray(this.selectedTour.attributes.item?.data)) {
          this.selectedTour.attributes.item.data.forEach(item => {
            oldIdToNameMap[item.id] = item.attributes.item.trim();
          });
        }

        const originalItemFactor = this.selectedTour.attributes.itemFactor || {};
        const originalMargin = this.selectedTour.attributes.margin || {};

        this.matchedItems.forEach(item => {
          const itemId = item.id;
          const itemName = item.attributes.item.trim();

          // Find if this item name existed in original tour to get its factor/margin
          const oldEntry = Object.entries(oldIdToNameMap).find(([id, name]) => name === itemName);
          if (oldEntry) {
            const oldId = oldEntry[0];
            itemFactor[itemId] = originalItemFactor[oldId] || 1;
            margin[itemId] = originalMargin[oldId] || 15;
          } else {
            itemFactor[itemId] = 1; // Default
            margin[itemId] = 15; // Default
          }
        });
      }

      // Prepare cloned data with a new year and name
      this.clonedTour = {
        ...this.selectedTour,
        attributes: {
          ...this.selectedTour.attributes,
          year: this.newYear,
          tourName: this.newTourName,
          tourCode: this.newTourCode,
          cruiseLine: this.newCruiseLine,
          item: this.matchedItems.map(matchedItem => ({ id: matchedItem.id })),
          cities: Array.isArray(this.selectedTour.attributes.cities?.data) ? this.selectedTour.attributes.cities.data.map(city => ({ id: city.id })) : [],
          port: this.selectedTour.attributes.port?.data ? { id: this.selectedTour.attributes.port.data.id } : null,
          remarks: this.missingItems.length > 0
            ? `Missing items:\n${this.missingItems.map((item, index) => `${index + 1}) ${item.name}`).join('\n')}`
            : '',
          sellPrice: null,
          overview: null,
          itemFactor: itemFactor,
          margin: margin
        }
      };
      if (this.matchedItems.length === 0 && this.missingItems.length === 0) {
        this.confirmationMessage = `No items found for the selected year. Do you want to create the tour with no items?`;
      } else if (this.matchedItems.length === 0) {
        this.confirmationMessage = `No items matched for the selected year. Do you still want to create the tour?`;
      } else {
        this.confirmationMessage = `Only ${this.matchedItems.length} items matched for the selected year:<br>`;
        this.confirmationMessage += `<ul>${this.matchedItems.map(item => `<li>${item.attributes.item}</li>`).join('')}</ul>`;
        this.confirmationMessage += `Missing items:<br>`;
        this.confirmationMessage += `<ul>${this.missingItems.map(item => `<li>${item.name}</li>`).join('')}</ul>`;
        this.confirmationMessage += `Do you still want to create the tour with missing items?`;
      }

      this.showCloneModal = false;
      this.showConfirmModal = true;
    },
    async createClonedTour() {
      // Clone the overview, and set the sellPrice to null
      const clonedOverview = this.selectedTour.attributes.overview
        ? this.selectedTour.attributes.overview.map(item => ({
          ...item,
          sellPrice: null
        }))
        : []; // If no overview exists, use an empty array

      this.clonedTour.attributes.overview = clonedOverview;
      const response = await this.$xhr.post('/api/tourrivers', { data: this.clonedTour.attributes });
      console.log('Cloned tour response:', response.data);
      this.$bvToast.toast('Tour cloned successfully!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
      this.fetchTours();
      this.showConfirmModal = false;
    },
    selectAll(event) {
      this.selectedTours = event.target.checked ? this.tours.map(tour => tour.id) : [];
    },
    resetFilters() {
      this.filters = { tourName: '', tourCode: '', cruiseLine: '', year: '', port: '' };
      localStorage.removeItem('lastTourAppliedFilters');
      this.fetchTours(1);
    },
    saveFilters() {
      localStorage.setItem('lastTourAppliedFilters', JSON.stringify(this.filters));
    },
    loadFilters() {
      const savedFilters = localStorage.getItem('lastTourAppliedFilters');
      if (savedFilters) {
        this.filters = JSON.parse(savedFilters);
      }
    },
    exportToExcel() {
      const selectedRows = this.tours.filter(tour => this.selectedTours.includes(tour.id));
      if (selectedRows.length === 0) {
        this.$bvToast.toast('No rows selected for export!', {
          title: 'Export Failed',
          variant: 'warning',
          solid: true
        });
        return;
      }
      generateExcel(selectedRows);
    },
    exportToExcelClient() {
      const selectedRows = this.tours.filter(tour => this.selectedTours.includes(tour.id));
      if (selectedRows.length === 0) {
        this.$bvToast.toast('No rows selected for export!', {
          title: 'Export Failed',
          variant: 'warning',
          solid: true
        });
        return;
      }
      generateExcelClient(selectedRows);
    }
  },
  watch: {
    filters: {
      handler() {
        this.saveFilters();
      },
      deep: true
    }
  },
};
</script>
<style scoped>
.filters-banner {
  background-color: #f8f9fa;
  padding: 10px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
}

.filters-left {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.tour-length-center {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  text-align: center;
}

.filters-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-item {
  min-width: 160px;
  max-width: 160px;
}

.search-bar {
  max-width: 300px;
}

.reset-btn,
.add-tour-btn {
  min-width: 100px;
}

.tour-count {
  font-weight: bold;
}

.custom-table {
  max-height: 65vh;
  overflow-y: auto;
  display: block;
}

.table-responsive {
  overflow-y: auto;
}

.table th,
.table td {
  text-align: center;
  width: 5%;
}


.table th:last-child,
.table td:last-child {
  width: 30%;
}

.table .thead-dark th {
  position: sticky;
  top: 0;
  z-index: 1;
  color: orange
}

.nested-table {
  width: 100%;
  border-collapse: collapse;
}

.nested-table th,
.nested-table td {
  padding: 2px;
  border: 1px solid #ddd;
}

.nested-table th {
  width: 20%;
}

.success-box {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 10px;
}

.danger-box {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  padding: 10px;
}

.tour-row:hover {
  background-color: #edc99b;
}

.context-menu {
  position: fixed;
  background-color: #e6e0e0;
  border: 1px solid #ddd;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  width: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 0;
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.context-menu li {
  padding: 10px;
  cursor: pointer;
  text-align: center;
}

.context-menu li:hover {
  background-color: #edc99b;
}

.align-items-center {
  align-items: center;
}
</style>
